<template>
  <el-container class="login-body">
    <el-container class="info-section el-col-12">
      <div class="panel">
        <h1>The Future of<br>Stock Surveillance</h1>
        <div>Sequire unlocks stock buyers' behaviors and trends for
          issuers of publicly traded companies</div>
        <div class="learn-more">
          <el-button type="text" v-track="{ event: 'login_learn' }">
            <a href="https://mysequire.com/" target="_blank">LEARN MORE</a>
          </el-button>
        </div>
      </div>
      <el-footer class="powered-by">Powered by SRAX.</el-footer>
    </el-container>
    <div class="form-section el-col-12">
      <div class="panel">
        <div class="content-img">
          <img :src="getLogo" alt="">
        </div>
        <div class="password-sent" v-if="passwordSent">
          <i class="icon-mail font-size-40 color-primary"/>
          <div class="black-title">Recovery email sent</div>
          <div class="subtitle">
            If you don&#39;t see the recovery email in your inbox,
            please check your <b>Spam</b> folder.
          </div>
          <router-link
            class="no-underline"
            to="/"
            v-track="{ event: 'password_reset_back' }"
          >
            Back to Login
          </router-link>
        </div>
        <div class="reset-password" v-else>
          <div class="blue-title">Reset password</div>
          <div class="subtitle">Enter your email address to receive a new password</div>
          <div class="blue-bit"/>
          <el-form
            class="login-form"
            :model="recoveryForm"
            ref="recoveryForm"
            :disabled="sendingRequest"
            :rules="rules"
            @submit.native.prevent
            @keyup.enter.native="submitForm('recoveryForm')"
            size="medium"
          >

            <el-form-item
              v-if="!passwordSent"
              label="Email"
              prop="email"
            >
              <el-input v-model="recoveryForm.email" type="email"> </el-input>
            </el-form-item>

            <el-form-item class="submit-button" >
              <el-button
                type="primary"
                @click="submitForm('recoveryForm')"
                class="btn-block"
                :disabled="sendingRequest"
                size="medium"
                v-track="{ event: 'password_reset_send' }"
              >
                Send password
              </el-button>

            </el-form-item>
            <div class="text-center"><a href="/">Go back to login</a></div>
          </el-form>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import { getBrand } from '@/whitelabel.config';
import IAM_API from '@/store/iamService';

export default {
  name: 'passwordRecovery',
  data() {
    return {
      sendingRequest: false,
      brand: getBrand(),
      passwordSent: false,
      recoveryForm: {
        email: '',
      },
      rules: {
        email: [
          {
            required: true,
            message: 'The email field is required.',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'The email field must be a valid email.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isDark: (state) => state.layout.isDark,
    }),
    getLogo() {
      if (this.isDark && Object.prototype.hasOwnProperty.call(this.brand.logoList, 'loginDark')) return this.brand.logoList.loginDark;
      return this.brand.logoList.login;
    },
  },
  methods: {
    submitForm(formName) {
      try {
        this.$refs[formName].validate((valid) => {
          if (!valid) return;
          this.passwordSubmit();
        });
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    passwordSubmit() {
      this.sendingRequest = true;

      // Construct the request body
      const passwordRecovery = {
        email: this.recoveryForm.email,
        callback: `${window.location.origin}/newPassword`,
      };

      // Make the request
      IAM_API({
        method: 'post',
        url: '/passwordRecovery',
        data: { password_recovery: passwordRecovery },
      }).then(() => {
        this.sendingRequest = false;
        this.passwordSent = true;
      }).catch((e) => {
        this.sendingRequest = false;
        Vue.config.errorHandler(e);
      });
    },
  },
  beforeMount() {
    const html = document.getElementById('html-base');

    if (this.$store.state.layout.isDark) html.classList.add('dark');
    else html.classList.remove('dark');
  },
};
</script>

<style scoped lang="scss">
  @import "~@/styles/variables.scss";
  @import "~@/styles/login.scss";
</style>
